import $ from "jquery";
import AmenityMap from "./am_amenity_map.js";
import AmenityAccordion from "./am_amenity_accordion.js";

$(document).ready(function () {
  new AmenityMap();
  new AmenityAccordion();

  console.log('sup');
});
